
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reset-password/thank-you",
      function () {
        return require("private-next-pages/reset-password/thank-you.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reset-password/thank-you"])
      });
    }
  